var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1444_4864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 2.5H11V2C11 1.17156 10.3284 0.5 9.5 0.5H7.5C6.67156 0.5 6 1.17156 6 2V2.5H3.25C2.55966 2.5 2 3.05966 2 3.75V4.75C2 5.02616 2.22384 5.25 2.5 5.25H14.5C14.7762 5.25 15 5.02616 15 4.75V3.75C15 3.05966 14.4403 2.5 13.75 2.5ZM7 2C7 1.72438 7.22437 1.5 7.5 1.5H9.5C9.77563 1.5 10 1.72438 10 2V2.5H7V2Z",
    fill: "#EF4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94921 6.25C2.85999 6.25 2.7889 6.32456 2.79315 6.41369L3.20565 15.0712C3.24377 15.8725 3.9019 16.5 4.70377 16.5H12.2969C13.0988 16.5 13.7569 15.8725 13.795 15.0712L14.2075 6.41369C14.2118 6.32456 14.1407 6.25 14.0515 6.25H2.94921ZM10.5003 7.5C10.5003 7.22375 10.7241 7 11.0003 7C11.2766 7 11.5003 7.22375 11.5003 7.5V14C11.5003 14.2762 11.2766 14.5 11.0003 14.5C10.7241 14.5 10.5003 14.2762 10.5003 14V7.5ZM8.00034 7.5C8.00034 7.22375 8.22409 7 8.50034 7C8.77659 7 9.00034 7.22375 9.00034 7.5V14C9.00034 14.2762 8.77659 14.5 8.50034 14.5C8.22409 14.5 8.00034 14.2762 8.00034 14V7.5ZM5.50034 7.5C5.50034 7.22375 5.72409 7 6.00034 7C6.27659 7 6.50034 7.22375 6.50034 7.5V14C6.50034 14.2762 6.27659 14.5 6.00034 14.5C5.72409 14.5 5.50034 14.2762 5.50034 14V7.5Z",
    fill: "#EF4A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1444_4864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.36e823b804364938fdc7d03c31582e58.svg";
export { ForwardRef as ReactComponent };